// extracted by mini-css-extract-plugin
module.exports = {"item":"subject-item_item__AutnO"};